
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/acceptcredit/privacy-policy",
      function () {
        return require("private-next-pages/acceptcredit/privacy-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/acceptcredit/privacy-policy"])
      });
    }
  